import { ProfileDanceStyleInterface } from '../../..';

export class ProfileDanceStyleRequestDto implements ProfileDanceStyleInterface {
  translationKey: string;
  experience: number;
  isPairDance: boolean;
  isLeader: boolean;
  isFollower: boolean;
}
